import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NzInputModule,
    NzIconModule,
    NzSelectModule,
    NzButtonModule,
    NzPaginationModule,
    NzAvatarModule,
    NzDropDownModule,
    NzDividerModule,
    NzModalModule,
    NzNotificationModule,
    NzUploadModule,
    NzImageModule,
    NzDatePickerModule,
    NzCascaderModule,
    NzTimePickerModule,
    NzTreeSelectModule,
    NzFlexModule,
    NzTransferModule,
    NzTreeModule,
    NzFormModule,
    NzCheckboxModule,

    NzSpinModule,
    NzMenuModule,
    NzLayoutModule,
    NzTreeViewModule,
    NzSkeletonModule,
    NzBadgeModule,
    NzTabsModule,
    NzEmptyModule,
  ],
  exports: [
    NzInputModule,
    NzIconModule,
    NzSelectModule,
    NzButtonModule,
    NzPaginationModule,
    NzAvatarModule,
    NzDropDownModule,
    NzDividerModule,
    NzModalModule,
    NzNotificationModule,
    NzUploadModule,
    NzImageModule,
    NzDatePickerModule,
    NzCascaderModule,
    NzTimePickerModule,
    NzTreeSelectModule,
    NzFlexModule,
    NzCardModule,
    NzTransferModule,
    NzTreeModule,
    NzFormModule,
    NzCheckboxModule,
    NzSpinModule,
    NzMenuModule,
    NzLayoutModule,
    NzTreeViewModule,
    NzSkeletonModule,
    NzAutocompleteModule,
    NzToolTipModule,
    NzBadgeModule,
    NzTabsModule,
    NzEmptyModule,
  ],
})
export class AntModule {}
